var styles = {"box__inner":"Wrapper_box__inner_1dy9n_1","box":"Wrapper_box_1dy9n_1","form-container":"Wrapper_form-container_1dy9n_21"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
